import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { logError } from 'app/core/logger/logger.service';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    logError('Bootstrap error:', err)
);
